export default "__VITE_ASSET__DkgqIkGX__"